import { render, staticRenderFns } from "./OrderKidsMonthDialog.vue?vue&type=template&id=bc831fa4&scoped=true"
import script from "./OrderKidsMonthDialog.vue?vue&type=script&lang=js"
export * from "./OrderKidsMonthDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderKidsMonthDialog.vue?vue&type=style&index=0&id=bc831fa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc831fa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc831fa4')) {
      api.createRecord('bc831fa4', component.options)
    } else {
      api.reload('bc831fa4', component.options)
    }
    module.hot.accept("./OrderKidsMonthDialog.vue?vue&type=template&id=bc831fa4&scoped=true", function () {
      api.rerender('bc831fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKidsMonthDialog.vue"
export default component.exports